function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircle = function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.6-.2C34-.2 44.1 9.9 44.1 22.3S34 44.8 21.6 44.8-.9 34.7-.9 22.3 9.2-.2 21.6-.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "inherit"
    },
    transform: "translate(.854 .205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5 14.6 8 8-8 8",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(.854 .205)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "&quot",
      fontSize: 12
    },
    transform: "translate(1000 1000)"
  }, "Chevvy"));
};
export default SvgArrowCircle;